interface ProductCacheEntry<T> {
    readonly expiresAt: number;
    readonly value: T;
}

export class ProductCache {
    private readonly entries = new Map<string, ProductCacheEntry<unknown>>();

    public constructor(private readonly durationMilliseconds: number = 60_000) {
        if (!Number.isFinite(durationMilliseconds) || durationMilliseconds < 0) {
            throw new TypeError(
                "Product cache duration must be a finite number greater than or equal to zero.",
            );
        }
    }

    public get<T>(key: string): T | undefined {
        const entry = this.entries.get(key);

        if (entry === undefined) {
            return undefined;
        }

        if (entry.expiresAt <= Date.now()) {
            this.entries.delete(key);
            return undefined;
        }

        return entry.value as T;
    }

    public set<T>(key: string, value: T): T {
        if (this.durationMilliseconds === 0) {
            return value;
        }

        this.entries.set(key, {
            expiresAt: Date.now() + this.durationMilliseconds,
            value,
        });

        return value;
    }

    public clear(): void {
        this.entries.clear();
    }
}
